import Component from '@glimmer/component';
import { action } from '@ember/object';

interface UiConfirmModalSignature {
  Args: {
    Named: {
      isOpen: boolean;
      onClose: () => void;
      onConfirm: (close: () => void) => void;
      confirmLabel: string;
      cancelLabel?: string;
      isConfirming?: boolean;
      closeOnConfirm?: boolean;
      icon?: string;
      isDestructive?: boolean;
      containerClass?: string;
    };
  };
  Blocks: {
    title: [];
    content: [];
  };
}

export default class UiConfirmModalComponent extends Component<UiConfirmModalSignature> {
  get icon() {
    return this.args.icon ?? 'exclamation-triangle';
  }

  get isDestructive() {
    return this.args.isDestructive ?? true;
  }

  get closesOnConfirm() {
    return this.args.closeOnConfirm ?? true;
  }

  @action
  handleConfirm(close: () => void) {
    if (this.closesOnConfirm) close();

    this.args.onConfirm(close);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::ConfirmModal': typeof UiConfirmModalComponent;
    'ui/confirm-modal': typeof UiConfirmModalComponent;
  }
}
